import { CustomIcons } from './CustomIcons'
export default CustomIcons
export { iconList } from './iconList'
